import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ReplaceItemsCommand from './replaceItemsCommand';

/**
 * Set item align command
 *
 * @class SetItemAlignCommand
 * @extends AbstractCommand
 */
export default class SetItemAlignCommand extends ReplaceItemsCommand {
    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        if (this.replacements.length > 1) {
            return `Change alignment of ${this.replacements.length} items`;
        }
        return 'Change alignment of item';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SetItemAlignCommand = SetItemAlignCommand;
